import toNumber from 'lodash/toNumber'

export const fetchTokenUSDValue = async (chainId: string | number, tokenAddresses: string) => {
  const result: { derivedUSD: string } = await fetch(
    `https://token_price.dackieswap.workers.dev/v3/${chainId}/token-prices/${tokenAddresses}`,
  ).then((res) => res.json())

  return toNumber(result.derivedUSD)
}
